import React, { useState } from "react";
import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import ReactDOM from "react-dom";
import * as Components from "./Component";
import { Flex, Form, FormProps, notification, Button, Input, App, ConfigProvider, Card, AutoComplete, AutoCompleteProps, Modal } from "antd";
import {  LoadingOutlined, LockOutlined,  UserOutlined } from "@ant-design/icons";
import axios from "axios";
import R from './img/homepage.jpg'


type FieldType = {
    username?: string;
    password?: string;
};

export function SignInMock() {

  const location = useLocation();
  const navigate = useNavigate();

  const [signIn, toggle] = useState(true);
  const [ForgottenMod,setForgottenMod] = useState(false);
  const [error, setError] = useState(false);
  const [role, setRole] = useState('researcher');
  const [status,setstatus] = useState('')
  const [options, setOptions] = React.useState<AutoCompleteProps['options']>([]);
  const [loading,setLoading]=useState(false);
  const [successReset,setsuccessReset]=useState(false);
  const [FailedReset,setFailedResetReset]=useState(false);

  const [RegistrationForm] = Form.useForm();
  const [ForgotForm] = Form.useForm();
  const [isFormValid, setIsFormValid] = useState(false);


  const { message, notification } = App.useApp();

  const handleSearch = (value: string) => {
    setOptions(() => {
    if (!value || value.includes('@')) {
        return [];
    }
    return ['gmail.com', 
            'yahoo.com', 
            'hotmail.com', 
            'outlook.com', 
        ].map((domain) => ({
        label: `${value}@${domain}`,
        value: `${value}@${domain}`,
    }));
    });
};

const handleFormChange = () => {
    const hasErrors = RegistrationForm
    .getFieldsError()
    .some(({ errors }) => errors.length > 0);
    const hasTouched = RegistrationForm.isFieldsTouched(true);
    setIsFormValid(!hasErrors && hasTouched);
};

async function SendData (mode:any) {
    if(mode == 'register'){
        setLoading(true);
        
        const RegisterFormData = RegistrationForm.getFieldsValue()
        const data = {
            THfullname:RegisterFormData.THfullname,
            ENfullname:RegisterFormData.ENfullname,
            user_email:RegisterFormData.user_email,
            phonenumber:RegisterFormData.phonenumber,
            user_pass:RegisterFormData.user_pass,
        }

        try{
            const response = await axios.post(`${process.env.REACT_APP_BASE}/newUserRegistration`,data)
            if(response.status == 200){
                setLoading(false);
                setsuccessReset(true);
                alert('สมัครสำเร็จ กรุณาตรวจสอบemailของท่าน');
                setTimeout(() => {
                    setsuccessReset(false);
                  }, 3000);
            }
        }catch (err) {
            if (axios.isAxiosError(err)) {
                // TypeScript now knows 'err' is AxiosError
                setLoading(false);
                if (err.response) {
                  console.error('Backend returned error:', err.response.data);
                  alert(err.response.data.error || 'An error occurred.');
                } else if (err.request) {
                  console.error('No response from server:', err.request);
                  alert('Server did not respond. Please try again later.');
                } else {
                  console.error('Request setup error:', err.message);
                  alert('Something went wrong. Please try again.');
                }
              } else {
                console.error('Unknown error:', err);
                alert('An unexpected error occurred.');
              }
          }
     
    }
    else if(mode == 'forgotten'){
        setForgottenMod(false);
        setLoading(true);

        const ForgotFormData = ForgotForm.getFieldsValue()
        const data = {
            email:ForgotFormData.email,
        }

        try{
            const response = await axios.post(`${process.env.REACT_APP_BASE}/ForgotPassword`,data)
            if(response.status == 200){
                setLoading(false);
                setsuccessReset(true);
                setTimeout(() => {
                    setsuccessReset(false);
                  }, 3000);
                  alert('เปลี่ยนรหัสผ่านสำเร็จ โปรดตรวจสอบเมลของท่าน');
            }
        }catch (err) {
            if (axios.isAxiosError(err)) {
                // TypeScript now knows 'err' is AxiosError
                setLoading(false);
                if (err.response) {
                  // ✅ Server responded with error status
                  console.error('Backend returned error:', err.response.data);
                  alert(err.response.data.error || 'An error occurred.');
                } else if (err.request) {
                  // ❌ Request made, but no response
                  console.error('No response from server:', err.request);
                  alert('Server did not respond. Please try again later.');
                } else {
                  // ⚠️ Something else happened
                  console.error('Request setup error:', err.message);
                  alert('Something went wrong. Please try again.');
                }
              } else {
                // The error is not from axios
                console.error('Unknown error:', err);
                alert('An unexpected error occurred.');
              }
          }
      


        // setTimeout(() => {
        //   setLoading(false);
        //   setsuccessReset(true);
      
        //   setTimeout(() => {
        //     setsuccessReset(false);
        //   }, 3000);
      
        // }, 5000);
    }
}

  const fetchifStaff = async (departments:any)=>{
    const availablePositions = [];
        for(const department of departments){
            if(department.Fac_ID==112){
                availablePositions.push(department);
            } 
        }
        return availablePositions; 
}
  
  const fetchimg = async (user:any) =>{
    try{
        console.log(user)
        await axios.get(`${process.env.REACT_APP_IMG}/get-researcher-team/${user}`).then(res=>
        { 
          if(res.data){
            console.log(res.data)
            sessionStorage.setItem("user_picture",res.data.userResult[0].picture)
          }else{
            sessionStorage.setItem("test","test")
          }
        }
          
        )}catch (error) {
            console.error("Error fetching img", error);
        }
}

  const Login: FormProps<FieldType>['onFinish'] = async (values) => {
    const data = { username: values.username, password: values.password };
    try{
        sessionStorage.setItem("role","Opening");
        console.log('researcher')

        try {
            const response = await axios.post(
              "https://i.vu.ac.th/digitalId/vuapiver1/auth/login.php",
              data
            );
          
            if (response.status === 200) {
              console.log("insider");
          
              const {
                user_id,
                fullname,
                address,
                department,
                token,
                user_type,
                fac_name,
                fac_id,
                LevelEdu,
              } = response.data;
          
              await fetchimg(user_id);
              sessionStorage.setItem("token", token);
              sessionStorage.setItem("user", user_id);
              sessionStorage.setItem("fullname", fullname);
              sessionStorage.setItem("user_type", user_type);
              sessionStorage.setItem("status", "Insider");
              
          
              if (role === "researcher") {
                if (department) {
                  setstatus("Staff");
                  sessionStorage.setItem("Status", "Staff");
                  sessionStorage.setItem("POS_ID", JSON.stringify(department));
                  if (department.length > 1) {
                    sessionStorage.setItem("IsMultiplePos", "yes");
                  } else {
                    sessionStorage.setItem("Fac_ID", department[0].Fac_ID);
                  }
                } else {
                  setstatus("student");
                  sessionStorage.setItem("Status", "student");
                  sessionStorage.setItem("edu_level", JSON.stringify(LevelEdu));
                  sessionStorage.setItem("Fac_ID", fac_id);
                  sessionStorage.setItem("Fac_name", fac_name);
                }
          
                setTimeout(() => window.location.reload(), 500);
              }
            } else {
              throw new Error("Insider API did not return 200");
            }
          } catch (err) {
            try {
              console.log("outsider");
          
              const response = await axios.post(
                `${process.env.REACT_APP_BASE}/auth/Login`,
                data
              );
          
              if (response.status === 200) {
                sessionStorage.setItem("status", "Outsider");
                const {
                  token,
                  data: [
                    {
                      OutsiderID,
                      THfullname,
                      user_email,
                      phonenumber,
                      position,
                      facility,
                      wp_address,
                      home_address,
                    },
                  ],
                } = response.data;
          
                sessionStorage.setItem("token", token);
                sessionStorage.setItem("user", OutsiderID);
                sessionStorage.setItem("fullname", THfullname);
                sessionStorage.setItem("userEmail", user_email);
                sessionStorage.setItem("phonenumber", phonenumber);
                sessionStorage.setItem("position", position);
                sessionStorage.setItem("facility", facility);
                sessionStorage.setItem("wp_address", wp_address);
                sessionStorage.setItem("home_address", home_address);
          
                setTimeout(() => window.location.reload(), 500);
              } else {
                throw new Error("Outsider API did not return 200");
              }
            } catch (err2) {
              // 3) Both failed → show error
              console.error("Login failed", err2);
              alert("เข้าสู่ระบบไม่สำเร็จ");
            }
          }

    }
    catch (error) {
        setError(true);
        notification.error({
            message: "เข้าสู่ระบบไม่สำเร็จ",
        });
    }
}

  useEffect(() => {
    if (location.pathname !== '/') {
      navigate('/VU_HREC');
    }
  }, [location.pathname, navigate]);

  return (
    <ConfigProvider
        theme={{
            components: {
                Form: { labelColor: 'black' },
                Segmented: {
                    itemActiveBg: '#D4BDAC',
                    itemSelectedBg: '#FFF1DB',
                    trackBg: 'gray',
                    // itemColor: 'white',
                },
            },
            token: { fontFamily: 'Kanit' },
        }}
    >   
      <div 
        style={{
          height: '100vh',
          width: '100vw',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          backgroundImage: `url(${R})`,
          backgroundSize: '100% 100%',  
          backgroundPosition: 'center',
          backgroundRepeat: 'no-repeat'
      }}>
        <Components.Container>
        <Components.SignUpContainer signingIn={signIn}>
            <Components.Form>
            <Components.Title>สมัครสมาชิก</Components.Title>
            <Form
                    form={RegistrationForm}
                    labelCol={{ span: 10 }}
                    wrapperCol={{ span: 17 }}
                    onFieldsChange={handleFormChange}
                >
                    <Form.Item
                    name="THfullname"
                    label="ชื่อ-สกุลภาษาไทย"
                    rules={[{ required: true, message: 'ชื่อไม่สามารถปล่อยว่างได้' }]}
                    >
                    <Input placeholder="ex. นายสมชาย ใจหมาย" autoComplete="off" />
                    </Form.Item>

                    <Form.Item
                    name="ENfullname"
                    label="ชื่อ-สกุลภาษาอังกฤษ"
                    rules={[{ required: true, message: 'นามสกุลไม่สามารถปล่อยว่างได้' }]}
                    >
                    <Input placeholder="ex. Mr.Somchai Jaimai" autoComplete="off" />
                    </Form.Item>

                    <Form.Item
                    name="user_email"
                    label="email"
                    rules={[
                        { required: true, message: 'email ไม่สามารถปล่อยว่างได้' },
                        {
                        pattern: /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
                        message: 'รูปแบบ email ไม่ถูกต้อง',
                        },
                    ]}
                    >
                        <AutoComplete
                            placeholder="ex. somchai@mail.com"
                            onSearch={handleSearch}
                            options={options}
                            />
                    </Form.Item>

                    <Form.Item
                    name="phonenumber"
                    label="เบอร์โทร"
                    rules={[{ required: true, message: 'เบอร์โทรไม่สามารถปล่อยว่างได้' }]}
                    >
                    <Input
                    placeholder="ex. 0888888888"
                     autoComplete="off" />
                    </Form.Item>

                    <Form.Item
                    name="user_pass"
                    label="รหัสผ่าน"
                    rules={[{ required: true, message: 'กรุณากรอกรหัสผ่าน' }]}
                    hasFeedback
                    >
                        <Input.Password placeholder="กรุณากรอกรหัสผ่านที่มีความยาวไม่เกิน16ตัวอักษร" autoComplete="new-password" name="user_pass" />
                    </Form.Item>

                    <Form.Item
                    name="comfirmpassword"
                    label="ยืนยันรหัสผ่าน"
                    dependencies={['user_pass']}
                    hasFeedback
                    rules={[
                        { required: true, message: 'กรุณายืนยันรหัสผ่าน' },
                        ({ getFieldValue }) => ({
                        validator(_, value) {
                            if (!value || getFieldValue('user_pass') === value) {
                            return Promise.resolve();
                            }
                            return Promise.reject(new Error('รหัสผ่านของท่านไม่ตรงกัน'));
                        },
                        }),
                    ]}
                    >
                        <Input.Password placeholder="กรุณากรอกรหัสผ่านอีกครั้งให้เหมือนกัน" autoComplete="new-password" />
                    </Form.Item>
                </Form>

                <Card>
                    <p>ชื่อผู้ใช้งานของท่านจะเป็นemailของท่านเอง</p>
                </Card>
                <br/>
                <Flex justify='flex-end'>
                    <Button type='primary' disabled={!isFormValid} onClick={()=>SendData('register')}>สมัคร</Button>
                </Flex>
            </Components.Form>
        </Components.SignUpContainer>
        <Components.SignInContainer   style={{fontFamily:'Kanit'}} signingIn={signIn}>
        <Components.Form>
        <Components.Title>เข้าสู่ระบบ</Components.Title>
            <Form
                className="text-white"
                name="basic"
                onFinish={Login}
                >
                <Form.Item<FieldType>
                name="username"
                rules={[{ required: true, message: 'กรุณากรอกชื่อผู้ใช้งาน' }]}
                >
                <Input
                    size="large"
                    placeholder="ชื่อผู้ใช้งาน"
                    prefix={<UserOutlined />}
                />
                </Form.Item>
                <Form.Item<FieldType>
                name="password"
                rules={[{ required: true, message: 'กรุณากรอกรหัส' }]}
                >
                <Input.Password
                    size="large"
                    prefix={<LockOutlined />}
                    placeholder="รหัสผ่าน"
                />
                </Form.Item>

                <Button
                    className="text-xl"
                    size="large"
                    style={{ width: 350, color: 'white', backgroundColor: '#024f4a' }}
                    type="primary"
                    htmlType="submit"
                >
                    เข้าสู่ระบบ
                </Button>
            </Form>
            <Flex justify="center">
            <p style={{ margin: 0 }}>ลืมรหัสผ่าน?</p>&nbsp;
            <p style={{ margin: 0 }}>
                <a onClick={() => setForgottenMod(true)}>กดที่นี่เพื่อรีเซ็ตรหัสผ่าน</a>
            </p>
            </Flex>
            <hr/>
            <Flex justify="center">
            <p style={{ margin: 0 }}>หมายเหตุ : หากท่านเป็นบุคลากรหรือนักศึกษาของมหาวิทยาลัยวงษ์ชวลิตกุล</p>
            </Flex>

            <Flex justify="center">
            <p style={{ margin: 0 }}>กรุณาติดต่อศูนย์เทคโนโลยีสารสนเทศ</p>
            </Flex>
            </Components.Form>
        </Components.SignInContainer>
        <Modal
            open={ForgottenMod}
            onCancel={() => setForgottenMod(false)}
            footer={null}
            centered
            >
            <h1>ลืมรหัสผ่าน</h1>
            <hr />
            <p>กรุณากรอก email ของท่านที่ใช้สมัครกับเรา เพื่อรีเซ็ตรหัสผ่าน</p>
            <p>หมายเหตุ หากท่านเป็นบุคลากรหรือนักศึกษาของมหาวิทยาลัยวงษ์ชวลิตกุลที่ลืมรหัสผ่าน กรุณาติดต่อศูนย์เทคโนโลยีสารสนเทศ</p>
            <br />
            <Form form={ForgotForm} layout="vertical"> 
                <Form.Item
                label={<span style={{ fontWeight: 'bold' }}>Email</span>}
                name="email"
                rules={[
                    { required: true, message: 'กรุณากรอกอีเมล' },
                    {
                    pattern: /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
                    message: 'รูปแบบอีเมลไม่ถูกต้อง',
                    },
                ]}
                >
                    <AutoComplete
                        onSearch={handleSearch}
                        options={options}
                        />
                </Form.Item>
                <br/>
                <Flex justify='center'><Button onClick={()=>SendData('forgotten')} type='primary'>รีเซ็ตรหัสผ่าน</Button></Flex>
            </Form>
            </Modal>
        <Components.OverlayContainer signingIn={signIn}>
            <Components.Overlay signingIn={signIn}>
            <Components.LeftOverlayPanel  style={{fontFamily:'Kanit'}} signingIn={signIn}>
                <Components.Title>มีสมาชิกอยู่แล้ว?</Components.Title>
                <Components.Paragraph>
                โปรดไปยังหน้าเข้าสู่ระบบ
                </Components.Paragraph>
                <Components.GhostButton  style={{fontFamily:'Kanit'}} onClick={() => toggle(true)}>
                เข้าสู่ระบบ
                </Components.GhostButton>
            </Components.LeftOverlayPanel>
            <Components.RightOverlayPanel  style={{fontFamily:'Kanit'}} signingIn={signIn}>
                <Components.Title>ยินดีต้อนรับเข้าสู่ระบบยื่นขอพิจารณาจริยธรรมวิจัย</Components.Title>
                <Components.Title>มหาวิทยาลัยวงษ์ชวลิตกุล</Components.Title>

                <Components.Paragraph style={{fontFamily:'Kanit'}}>
                    ยังไม่เคยสมัครสมาชิก?
                </Components.Paragraph>
                <Components.GhostButton  style={{fontFamily:'Kanit'}} onClick={() => toggle(false)}>
                    สมัครสมาชิกใหม่
                </Components.GhostButton>
                <Components.Paragraph style={{fontFamily:'Kanit'}}>
                    เป็นกรรมการหรือเจ้าหน้าที่?
                </Components.Paragraph>
                <Components.GhostButton
                  style={{ fontFamily: 'Kanit' }}
                  onClick={() => {
                    sessionStorage.setItem('InsiderLogin', 'Yes');
                    setTimeout(() => {
                      window.location.reload();
                    }, 100);
                  }}
                >
                  เข้าสู่ระบบเจ้าหน้าที่/กรรมการ
                </Components.GhostButton>
                <br/>
                <a target='_blank' href="https://drive.google.com/file/d/1GDGynWNKiOmluUz5CB-Mnm1jroig3mD_/view?usp=drive_link">
                <Components.GhostButton
                  style={{ fontFamily: 'Kanit' }}
                >
                  คู่มือการใช้งาน
                </Components.GhostButton></a>
            </Components.RightOverlayPanel>
            </Components.Overlay>
        </Components.OverlayContainer>
        </Components.Container>
      </div>
    </ConfigProvider>
  );
}
